export default {
    ocean:{
        en:'ocean view',
        tc:'維港景',
        sc:'維港景'
    },
    text_1:{
        en:'The Ocean View nestled along the coastline, offers stunning habour views and luxurious accommodations. Each room features floor-to-ceiling windows, perfect for relaxation. Whether for a romantic getaway or a family vacation, the Ocean View is the perfect choice for an idyllic escape.',
        tc:'坐落在海岸線的維港景房，提供令人驚嘆的維港景和豪華住宿。每間客房均配有落地窗，非常適合放鬆。無論是對於一個浪漫之旅或家庭度假，維港景房是您的最佳選擇田園詩般的度假的完美選擇。',
        sc:'坐落在海岸線的維港景房，提供令人驚嘆的維港景和豪華住宿。每間客房均配有落地窗，非常適合放鬆。無論是對於一個浪漫之旅或家庭度假，維港景房是您的最佳選擇田園詩般的度假的完美選擇。'
    },
    nearBy:{
        en:'nearby facilities',
        tc:'附近設施',
        sc:'附近设施'
    },
    otherInfo:{
        en:'other info',
        tc:'其他資訊',
        sc:'其他资讯'
    },
    inout:{
        en:'check-in & check-out',
        tc:'入住及退房',
        sc:'入住及退房'
    },
    inout_1:{
        en:'The check-in and check-out times are as follows.',
        tc:'入住和退房時間如下。',
        sc:'入住和退房时间如下。'
    },
    checkIn:{
        en:'Check - in',
        tc:'入住時間',
        sc:'入住时间'
    },
    checkOut:{
        en:'Check - out',
        tc:'退房時間',
        sc:'退房时间'
    },
    cc:{
        en:'Credit Card',
        tc:'信用卡',
        sc:'信用卡'
    },
    cc_1:{
        en:'We accept the following credit cards for payment of accommodation etc.',
        tc:'我們接受以下信用卡作為住宿等的付款方式。',
        sc:'我们接受以下信用卡作为住宿等的付款方式。'
    },
    cc_2:{
        en:'American Express, VISA, Mastercard, Diners Club, JCB card',
        tc:'美國運通、VISA、萬事達卡、Diners Club、JCB卡',
        sc:'美国运通、VISA、万事达卡、Diners Club、JCB卡'
    }
}